import styles from './ContinuarProcessos.module.scss';
import { useEffect, useState } from "react";
import http from "../../components/http";
import NavBar from "../../components/NavBar";
import { IProcesso } from "../../interfaces/processo.interface";
import CardProcesso from "../../components/Cards/CardProcesso";
import FormGastosProdutivos from "../../components/Form/FormGastosProdutivos";
import CardConfirma from '../../components/Cards/CardConfirma';
import { FormInsumos } from '../../components/Form/FormInsumos';

export function ContinuarProcessos() {
    const [processos, setProcessos] = useState<IProcesso[]>([]);
    const [sectionProccessos, setSectionProcessos] = useState<boolean>(true);
    const [clickConfirma, setClickConfirma] = useState<boolean>(false);
    const [processoSelecionado, setProcessoSelecionado] = useState<IProcesso | undefined>(undefined);

    const buscaDados = async () => {
        try {
            const response = await http.get('processos');
            setProcessos(response.data);
        } catch (error) {
            console.error('Erro ao buscar processos:', error);
        }
    };

    useEffect(() => {
        buscaDados();
    }, []);

    const continuarProcesso = (processo: IProcesso) => {
        setProcessoSelecionado(processo);
        setSectionProcessos(false);
    }

    const atualizaProcesso = async (depreciacao: number, energia: number, maoDeObra: number, quantidadeFinal: number, insumos: number) => {
        try {
            if (processoSelecionado !== undefined) {
                const processoAtualizado = {
                    quantidadeDeEntrada: quantidadeFinal,
                    despesaEnergia: processoSelecionado.despesaEnergia + energia,
                    despesaColaborador: processoSelecionado.despesaColaborador + maoDeObra,
                    despesaMaquina: processoSelecionado.despesaMaquina + depreciacao,
                    despesaInsumos: processoSelecionado.despesaInsumos + insumos
                }

                const response = await http.put(`processos/${processoSelecionado?.id}`, processoAtualizado);
                console.log(response.data);
                window.location.reload();
            }
        } catch (error) {
            console.log('Erro ao atualizar o processo: ' + error);
        }
    }

    const finalizaProcesso = async () => {
        try {
            const response = await http.put(`processos/${processoSelecionado?.id}`, { fim: new Date(), finalizado: true });
            window.location.reload();
        } catch (error) {
            console.log('Erro ao finalizar o processo: ' + error);
        }
    }

    return (
        <main>
            <NavBar />

            <section className={styles.principal}>
                {sectionProccessos &&
                    <div className={styles.container}>
                        {processos
                            .filter(processo => !processo.finalizado) // Filtra os processos não finalizados
                            .map((processo) => (
                                <CardProcesso
                                    key={processo.id}
                                    produto={processo.produto}
                                    inicio={processo.inicio}
                                    onClick={() => continuarProcesso(processo)}
                                    finalizar={() => { setProcessoSelecionado(processo); setClickConfirma(true); setSectionProcessos(false) }}
                                />
                            ))
                        }
                    </div>
                }

                {!sectionProccessos && !clickConfirma &&
                    <FormGastosProdutivos
                        quantidadeEntrada={processoSelecionado?.quantidadeDeEntrada || 0}
                        onGetGastos={atualizaProcesso}
                    />
                }

                {clickConfirma &&
                    <CardConfirma
                        text={`Deseja finalizar o processo: ${processoSelecionado?.produto}?`}
                        onClick={finalizaProcesso}
                        cancela={() => window.location.reload()}
                    />
                }
            </section>
        </main>
    )
}